import React from 'react';
import PhoneInputWithCountry from 'react-phone-number-input';
import 'react-phone-number-input/style.css';

/**
 * International phone input with flag/country picker.
 * - Defaults to United Kingdom (+44).
 * - Stores E.164 value in form state (e.g. "+447123456789").
 * - onChange(e164OrEmpty)
 *
 * Backwards compatible with the old PhoneInput API: still accepts `value`,
 * `onChange`, `defaultCountryCode`, and a `className` that styles the inner
 * <input> like our other shadcn Inputs.
 */
const PhoneInput = React.forwardRef(({
  value = '',
  onChange,
  defaultCountry = 'GB',
  defaultCountryCode,        // legacy compat ("44" → GB)
  placeholder = '7XXX XXX XXX',
  className = '',
  ...rest
}, ref) => {
  // Legacy: callers passed defaultCountryCode="44". Map to ISO country.
  const country =
    defaultCountry ||
    (defaultCountryCode === '44' ? 'GB' : 'GB');

  return (
    <div className={`oc-phone-input ${className || ''}`} data-testid={rest['data-testid']}>
      <PhoneInputWithCountry
        ref={ref}
        international
        countryCallingCodeEditable={false}
        defaultCountry={country}
        value={value || undefined}
        onChange={(val) => onChange?.(val || '')}
        placeholder={placeholder}
      />
    </div>
  );
});

PhoneInput.displayName = 'PhoneInput';
export default PhoneInput;
